import styled from "styled-components";
import DatatableAntd from "components/datatable-antd";

export const Counter = styled.div`
  margin: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  border: 1px solid #E2E8F0;
  padding: 18px;
  border-radius: 8px;

  p {
    color: #fff;
    font-weight: bold;
    background-color: #12619C;
    padding: 4px 12px;
    border-radius: 15px;
  }
`;

export const RoundedTable = styled(DatatableAntd)`
  .ant-table {
    border-radius: 8px;
    overflow: hidden;
  }

  .ant-table-container {
    border-radius: 8px;
    overflow: hidden;
  }
`;
